// Mobile page shell — sticky branded top header + scrollable body + extra
// bottom padding so the sticky CTA + bottom nav never overlap content.
import { cn } from "@/lib/utils";
import { MobileHeader } from "./MobileHeader";

interface MobileShellProps {
  /** Section title shown in the branded sticky header. */
  title?: string;
  /** Optional right-aligned slot in the header (e.g. CreditsChip). */
  actions?: React.ReactNode;
  /**
   * Legacy escape hatch — render a fully custom header node instead of the
   * branded MobileHeader. Prefer `title` + `actions` for consistency.
   */
  header?: React.ReactNode;
  children: React.ReactNode;
  /** Reserve extra bottom space for a sticky CTA on top of the bottom nav. */
  withStickyCTA?: boolean;
  className?: string;
}

export const MobileShell = ({
  title,
  actions,
  header,
  children,
  withStickyCTA,
  className,
}: MobileShellProps) => {
  return (
    <div className={cn("relative flex min-h-screen flex-col px-5", className)}>
      {header ? (
        <div className="sticky top-0 z-30 -mx-5 border-b border-white/5 bg-background/85 px-5 pt-[max(env(safe-area-inset-top),12px)] pb-3 backdrop-blur-xl">
          {header}
        </div>
      ) : title ? (
        <MobileHeader title={title} actions={actions} />
      ) : null}
      <div className={cn("flex-1", withStickyCTA ? "pb-44" : "pb-8")}>
        {children}
      </div>
    </div>
  );
};
